module.exports = __webpack_public_path__ + "img/C05TechPaxDeorum_ua.2be78423.webp";